import VueAxios from "vue-axios";
import axios from "axios";
//Vue.use(VueAxios, axios);
//Vue.use(Vuex)
//const this.$store.state.baseapi = "http://127.0.0.1:8000/api/";
export default {
    data() {
      return {
       
      }
    },
  
    created() {
     
    },
  
    methods: {
     
        GET_MIRS: async function(data) {




      
        var result =  await axios
          ({
            method: 'GET',
            url: this.$store.state.baseapi+"mirs/"+data.id ,
            responseType: 'json',
            headers: {
          
              "Content-Type": "application/json",
              'X-Authorization': 'Bearer ' +this.$store.state.user.token
  
            },
              
            }
            
          )
          .then(
            response => {
           
              //context.commit('SET_USER_DEALS', { deals: response.data.data })
              return response.data;
            },
            err => {
              
              return null;
            }
          );
          return result;
  
  
  
  
  
      },
  
  
  
  

EDITAR_MIRS: async function(data) {



      
      var result =  await axios
        ({
          method: 'PUT',
          url: this.$store.state.baseapi+"mirs/"+data.id ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
          //QUITAR COMILLAS SOLO EN DATA 
          //'idmunicipio','idsecretaria','iddepartamento','identificacion','problema', 'efectos', 'causas', 
          idarbol_problema:data.idarbol_problema,
           
        
             texto:' ',
             objetivo:data.objetivo, 
              efecto:data.efecto, 
               componentes:data.componentes, 
          
     
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },


    CREAR_MIRS: async function(data) {



      
      var result =  await axios
        ({
          method: 'POST',
          url: this.$store.state.baseapi+"mirs/" ,
          responseType: 'json',
          headers: {
        
            "Content-Type": "application/json",
            'X-Authorization': 'Bearer ' +this.$store.state.user.token

          },
          data:{
          //QUITAR COMILLAS SOLO EN DATA 
          //'idmunicipio','idsecretaria','iddepartamento','identificacion','problema', 'efectos', 'causas', 
          idarbol_objetivo:data.idarbol_objetivo,
           
        
             //texto:' ',
             objetivo:data.objetivo, 
              efecto:data.efecto, 
               componentes:data.componentes, 
          
     
          }
            
          }
          
        )
        .then(
          response => {
         
            //context.commit('SET_USER_DEALS', { deals: response.data.data })
            return response.data;
          },
          err => {
            
            return null;
          }
        );
        return result;





    },




  }
}